import React from "react";
import { MentionsInput, Mention } from "react-mentions";
import { isEmpty } from "../hooks/constants";
import defaultStyle from "@components/MarketVisitReport/defaultStyle";
import defaultMentionStyle from "@components/MarketVisitReport/defaultMentionStyle";
import styles from "@components/MarketVisitReport/MarketVisitReport.module.css";

/**
 * UsersSectionRegular Component
 * Users section for non-MH3 and non-RBDM Collaborator user types
 * 
 * @param {Object} formData - Form data
 * @param {Function} onChange - Handler for form field changes
 * @param {Array} userName - Array of visited user names
 * @param {Array} productList - List of products for mentions
 * @param {Array} wssList - List of WSS for mentions
 * @param {Array} dealerList - List of dealers for mentions
 * @param {Object} characterLimitValidation - Character limit validation errors
 * @param {Object} formValidation - Form validation errors
 * @param {String} userType - Type of user
 * @param {Boolean} disable - Form disable state
 */
const UsersSectionRegular = ({
  formData,
  onChange,
  userName,
  productList,
  wssList,
  dealerList,
  characterLimitValidation,
  formValidation,
  userType,
  disable,
}) => {
  // Don't render for MH3 and RBDM Collaborator
  if (userType === "MH3" || userType === "RBDM Collaborator") {
    return null;
  }

  return (
    <>
      {/* Section Header */}
      <div className={`row m-0 ${styles.MarketVisitReport__headingBox}`}>
        <div className={`col-8 p-0 ${styles.MarketVisitReport__heading}`}>
          Users
        </div>
      </div>

      {/* User Names Visited */}
      <div className={styles.MarketVisitReport__selectableRows}>
        <label className={styles.MarketVisitReport__selectLabel}>
          Name(s) of key User(s) visited where any issue(s) reported
        </label>
        <input
          className={` ${styles.MarketVisitReport__selectField}`}
          style={{ paddingLeft: "8px" }}
          name="userVisited"
          value={userName?.length ? userName : formData?.userVisited}
          onChange={(e) => onChange(e)}
          maxLength={256}
          disabled={disable}
        />
        {characterLimitValidation?.userVisited && (
          <p className={styles.MarketVisitReport__validationErrors}>
            {characterLimitValidation?.userVisited}
          </p>
        )}
      </div>

      {/* Key Observations */}
      <div className={styles.MarketVisitReport__selectableRows}>
        <label className={styles.MarketVisitReport__selectLabel}>
          Key Observations/Issues faced by User(s)
        </label>
        <MentionsInput
          className={styles.MarketVisitRepor__input}
          value={isEmpty(formData?.keyObsUser) ? "" : formData?.keyObsUser}
          maxLength={2001}
          onChange={(e) => {
            onChange({
              target: {
                name: "keyObsUser",
                value: e.target.value,
              },
            });
          }}
          style={defaultStyle}
          disabled={disable}
        >
          <Mention
            trigger="@p"
            data={productList}
            style={defaultMentionStyle}
          />
          <Mention trigger="@w" data={wssList} style={defaultMentionStyle} />
          <Mention trigger="@d" data={dealerList} style={defaultMentionStyle} />
        </MentionsInput>
        {characterLimitValidation?.keyObsUser && (
          <p className={styles.MarketVisitReport__validationErrors}>
            {characterLimitValidation?.keyObsUser}
          </p>
        )}
      </div>

      {/* Issues Faced While Banking */}
      <div className={styles.MarketVisitReport__selectableRows}>
        <label className={styles.MarketVisitReport__selectLabel}>
          Mention the issues faced by them while banking/redeeming:
        </label>
        <textarea
          name="issuesFacedByBank"
          value={formData.issuesFacedByBank}
          rows="3"
          className={` ${styles.MarketVisitRepor__textArea}`}
          style={{ paddingLeft: "8px" }}
          onChange={(e) => onChange(e)}
          disabled={disable}
          maxLength={2001}
        />
        {characterLimitValidation?.issuesFacedByBank && (
          <p className={styles.MarketVisitReport__validationErrors}>
            {characterLimitValidation?.issuesFacedByBank}
          </p>
        )}
      </div>
    </>
  );
};

export default UsersSectionRegular;
